import React, { useState, useEffect, useContext } from "react";
import "./styles.scss";
import Lottie from "react-lottie";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import ModalCrud from "../../../Components/ModalCrud";
import { GetAllFeriados, deleteFeriadoById } from "../../../Services/ApiCalls";
import MainContext from "../../../Contexts/MainContext";
import SelectedFeriado from "../../../Components/RenderSelectedRow/Feriados/SelectedFeriado";
import AddSelectedFeriado from "../../../Components/RenderSelectedRow/Feriados/AddSelectedFeriado";
import HeaderInside from "../../../Components/HeaderInside";
import EmptyData from "../../../Components/EmptyData";
import { FaPen, FaTrash, FaSearch } from "react-icons/fa";
import { showToast } from "../../../Functions";

const LOADING = require("../../../Assets/animations/loading.json");

const Feriados: React.FC = () => {
    const {
        token,
        openMoreInfo,
        setOpenMoreInfo,
        hasCloseEditModal,
        addModalOpen,
        setaddModalOpen,
    } = useContext(MainContext);

    const [selectedFeriado, setSelectedFeriado] = useState({});
    const [filterText, setFilterText] = useState("");
    const [localRefresh, setLocalRefresh] = useState(false);

    const { dataAllFeriados, statusCodeAllFeriados } = GetAllFeriados(token, hasCloseEditModal || localRefresh);

    useEffect(() => {
        document.title = "Marca Ponto - Feriados";
        setOpenMoreInfo(false);
    }, []);

    const closeModal = () => {
        setaddModalOpen(false);
        return true;
    };

    const closeModalMoreInfo = () => {
        setOpenMoreInfo(false);
        return true;
    };

    const showMoreInfo = (dataFromRow: any) => {
        setOpenMoreInfo(true);
        setSelectedFeriado(dataFromRow);
    };

    const handleDelete = async (row: any) => {
        if (window.confirm(`Tem certeza que deseja excluir o feriado ${row.nome}?`)) {
            try {
                await deleteFeriadoById(token, row.id);
                showToast("SUCCESS", "Feriado excluído com sucesso", {});
                setLocalRefresh(!localRefresh);
            } catch (error) {
                showToast("ERROR", "Erro ao excluir feriado", {});
            }
        }
    };

    const customColumns = [
        {
            name: "Nome do Feriado",
            selector: (row: any) => row.nome,
            sortable: true,
            cell: (row: any) => <span className="fw-600">{row.nome}</span>
        },
        {
            name: "Data",
            selector: (row: any) => row.data,
            sortable: true,
            cell: (row: any) => {
                const dateParts = row.data.split("-");
                if (dateParts.length === 3) {
                    return <span>{`${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`}</span>;
                }
                return <span>{row.data}</span>;
            }
        },
        {
            name: "Tipo",
            selector: (row: any) => row.tipo,
            sortable: true,
            cell: (row: any) => (
                <span className={`badge-light ${row.tipo === "Nacional" ? "nacional" : "municipal"}`}>
                    {row.tipo}
                </span>
            )
        },
        {
            name: "Alíquota (%)",
            selector: (row: any) => row.aliquota,
            sortable: true,
            center: true,
            cell: (row: any) => <span className="text-purple">{row.aliquota}%</span>
        },
        {
            name: "Ações",
            center: true,
            width: "120px",
            cell: (row: any) => (
                <div className="row-actions">
                    <button className="btn-action edit" onClick={(e) => { e.stopPropagation(); showMoreInfo(row); }} title="Editar">
                        <FaPen size={14} />
                    </button>
                    <button className="btn-action delete" onClick={(e) => { e.stopPropagation(); handleDelete(row); }} title="Excluir">
                        <FaTrash size={14} />
                    </button>
                </div>
            )
        }
    ];

    const filteredItems = dataAllFeriados?.filter((item: any) => {
        return item.nome.toLowerCase().includes(filterText.toLowerCase());
    });

    return (
        <>
            <div className="feriados__wrapper">
                <div className="feriados__header">
                    <HeaderInside isHome={false} nome={"Feriados"} />
                </div>

                <div className="feriados__dashboard">
                    <div className="stat-card">
                        <div className="stat-icon users-icon">
                            🏖️
                        </div>
                        <div className="stat-info">
                            <h3>{dataAllFeriados?.length || 0}</h3>
                            <p>Feriados Cadastrados</p>
                        </div>
                    </div>
                    <div className="stat-actions">
                        <button className="btn-primary" onClick={() => setaddModalOpen(true)}>
                            + Novo Feriado
                        </button>
                    </div>
                </div>

                <div className="feriados__filter-bar">
                    <div className="search-group">
                        <FaSearch className="icon" />
                        <input 
                            type="text" 
                            placeholder="Buscar por nome do feriado..." 
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                        />
                    </div>
                </div>

                {statusCodeAllFeriados === 200 ? (
                    <div className="table__wrapper modern-table">
                        <DataTable
                            noHeader={true}
                            data={filteredItems || []}
                            columns={customColumns as any}
                            noDataComponent={<EmptyData hasMargin={true} />}
                            striped={false}
                            pagination={true}
                            onRowClicked={showMoreInfo}
                            pointerOnHover={true}
                            highlightOnHover={true}
                            customStyles={{
                                rows: {
                                    style: { minHeight: '60px' }
                                }
                            }}
                        />
                    </div>
                ) : (
                    <div className="animation__wrapper">
                        <Lottie options={{ loop: true, animationData: LOADING }} height={150} width={150} />
                        <h2>Carregando feriados 🧐</h2>
                    </div>
                )}
            </div>

            {addModalOpen && (
                <ModalCrud onClose={closeModal}>
                    <AddSelectedFeriado />
                </ModalCrud>
            )}

            {openMoreInfo && (
                <ModalCrud onClose={closeModalMoreInfo}>
                    {selectedFeriado ? <SelectedFeriado data={selectedFeriado} /> : ""}
                </ModalCrud>
            )}
        </>
    );
};
export default Feriados;
